import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import theme from "./theme";
import { DestrierThemeProvider } from "./ThemeContext";
import { DataCacheProvider } from "./DataCacheContext";
import { AuthProvider } from "./AuthContext";
import { LangProvider } from "./i18n";
import LandingPageWaitlist from "./components/LandingPageWaitlist";
import LoginPage from "./components/LoginPage";
import AuthCallback from "./components/AuthCallback";
import DashboardLayout from "./components/DashboardLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import ArchetypePage from "./components/ArchetypePage";
import WeaknessPage from "./components/WeaknessPage";
import StrengthsPage from "./components/StrengthsPage";
import ProgressPage from "./components/ProgressPage";
import OpeningsPage from "./components/OpeningsPage";
import PlayHabitsPage from "./components/PlayHabitsPage";
import OpponentsPage from "./components/OpponentsPage";
import SettingsPage from "./components/SettingsPage";
import TrainingRoomPage from "./components/TrainingRoomPage";
import HomePage from "./components/HomePage";
// import CustomCursor from "./components/CustomCursor";
import CookieConsent from "./components/CookieConsent";
import PrivacyPolicy from "./components/landing/PrivacyPolicy";
import TermsOfUse from "./components/landing/TermsOfUse";
import ContactPage from "./components/landing/ContactPage";

export default function App() {
  return (
    <LangProvider>
    <DestrierThemeProvider>
      <AuthProvider>
        <DataCacheProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* <style>{`*, *::before, *::after { cursor: none !important; }`}</style>
            <CustomCursor /> */}
            <Router>
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<LandingPageWaitlist />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfUse />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/auth/callback" element={<AuthCallback />} />

                {/* Dashboard (protected) */}
                <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
                  <Route index element={<HomePage />} />
                  <Route path="home" element={<HomePage />} />
                  <Route path="weaknesses" element={<WeaknessPage />} />
                  <Route path="strengths" element={<StrengthsPage />} />
                  <Route path="archetype" element={<ArchetypePage />} />
                  <Route path="progress" element={<ProgressPage />} />
                  <Route path="openings" element={<OpeningsPage />} />
                  <Route path="habits" element={<PlayHabitsPage />} />
                  <Route path="rivals" element={<OpponentsPage />} />
                  <Route path="training" element={<TrainingRoomPage />} />
                  <Route path="settings" element={<SettingsPage />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Router>
            <CookieConsent />
          </ThemeProvider>
        </DataCacheProvider>
      </AuthProvider>
    </DestrierThemeProvider>
    </LangProvider>
  );
}
